import axios from './axios'
import baseUrl from './pubilshSet'
import successImg from '@/assets/success.png'
import errorImg from '@/assets/error.png'
import warning from '@/assets/warning.png'
export default {
  imgUpLoadFileList: ['jpg', 'png', 'jpeg', 'bmp'],
  videoUpLoadFileList: ['mp4', 'mov'],
  alertTips (object) {
    alert(object.content)
    // let DOM = document.createElement('div')
    // if (object.type === 'success') {
    //   DOM.className = 'allTips success'
    // } else {
    //   DOM.className = 'allTips error'
    // }
    // // let html = `<span>${object.title}</span>: <span>${object.content}</span>`
    // let html = `<span>${object.content}</span>`
    // DOM.innerHTML = html
    // document.body.appendChild(DOM)
    // let tips = document.querySelectorAll('.allTips')
    // if (tips.length === 1) {
    //   setTimeout(() => {
    //     DOM.style.top = '40px'
    //   }, 10)
    //   DOM.style.right = '40%'
    // } else {
    //   DOM.style.top = parseInt(tips[tips.length - 2].style.top.replace('px', ''), 0) + (tips[tips.length - 2].clientHeight + 12) + 'px'
    // }
    // setTimeout(() => {
    //   DOM.style.right = '40%'
    //   setTimeout(() => {
    //     DOM.style.top = '-10%'
    //     setTimeout(() => {
    //       document.body.removeChild(DOM)
    //     }, 500)
    //   }, object.stayTime * 1000)
    // }, 10)
  },
  returnQuery (url, object) {
    if (object) {
      let html = ''
      for (let i in object) {
        html += '&' + i + '=' + object[i]
      }
      html = html.substr(1, html.length - 1)
      return url + '?' + html
    }
  },
  uploadFile (file) {
    let postFile = new FormData()
    postFile.append('file', file)
    var p = new Promise((resolve, reject) => {
      axios.post('/bank/upSign', postFile).then(msg => {
        resolve(msg.data)
      })
    })
    return p
  },
  uploadIdCardFile (file, type) {
    let postFile = new FormData()
    postFile.append('file', file)
    var p = new Promise((resolve, reject) => {
      axios.post('/file/uploadPictures', postFile, type).then(msg => {
        resolve(msg.data)
      })
    })
    return p
  },
  uploadIdCardVideo (file, type) {
    let postFile = new FormData()
    postFile.append('file', file)
    var p = new Promise((resolve, reject) => {
      axios.post('/file/uploadVideo', postFile, type).then(msg => {
        resolve(msg.data)
      }).catch(p => {
        reject(p)
      })
    })
    return p
  },
  getImgUrl (fileId) {
    return baseUrl.baseUrl + '/api/Assistant/DownloadFile?fileId=' + fileId
  },
  doubleComfirm (object) {
    let dom = document.createElement('div')
    dom.id = 'doubleConfirm'
    dom.classList.add('showAllmodel')
    let buttomHtmlConform = ''
    let buttomHtmlCancel = ''
    if (object.lang === 'EN') {
      buttomHtmlConform += `<abbr>Confirm</abbr>`
      buttomHtmlCancel += `<abbr>Cancel</abbr>`
    } else {
      buttomHtmlConform += `<abbr>确定</abbr>`
      buttomHtmlCancel += `<abbr>取消</abbr>`
    }
    let footHtml = ''
    if (object.buttonType === '2') {
      footHtml += `<button id="confirmButtom" class="blueButton">${buttomHtmlConform}</button>
          <button id="cancelButtom" class="cancelButtonhui magleft_2">${buttomHtmlCancel}</button>`
    } else {
      footHtml += `<button id="confirmButtom" class="blueButton">${buttomHtmlConform}</button>`
    }
    let imgUrl = ''
    if (object.type === 'error') {
      imgUrl += '<img style="margin: 10px 0" src="' + errorImg + '"  width="30%"/>'
    } else if (object.type === 'success') {
      imgUrl += '<img style="margin: 10px 0" src="' + successImg + '"  width="30%"/>'
    } else {
      imgUrl += '<img style="margin: 10px 0" src="' + warning + '"  width="30%"/>'
    }
    let html = `
      <div class="cover"></div>
      <div class="allalertModel">
        <div class="alertTitle">${object.title}</div>
        <div class="alertcontent">
          ${imgUrl}
          <div>${object.content}</div>
        </div>
        <div class="alertfoot">
            ${footHtml}
        </div>
      </div>`
    dom.innerHTML = html
    document.body.appendChild(dom)
    let confirmButtom1 = document.getElementById('confirmButtom')
    if (confirmButtom1) {
      confirmButtom1.onclick = function (e) {
        if (object.successFun) {
          object.successFun(e)
        }
        document.body.removeChild(document.getElementById('doubleConfirm'))
      }
    }
    let cancelButtom1 = document.getElementById('cancelButtom')
    if (cancelButtom1) {
      cancelButtom1.onclick = function (e) {
        if (object.errorFun) {
          object.errorFun(e)
        }
        document.body.removeChild(document.getElementById('doubleConfirm'))
      }
    }
  },
  // 性别
  returnGender (type) {
    switch (type) {
      case 'Female':
        return window.localStorage.getItem('lang') === '0' ? 'Female' : '女'
      case 'Male':
        return window.localStorage.getItem('lang') === '0' ? 'Male' : '男'
      case '':
        return '-'
    }
    return ''
  },
  // 时间格式
  returnDate (date, type) {
    if (date === null || date === '' || date === undefined) {
      return ''
    } else {
      let newDate = new Date(date)
      let year = newDate.getFullYear()
      let month = newDate.getMonth() + 1
      let Todate = newDate.getDate()
      let hour = newDate.getHours()
      let min = newDate.getMinutes()
      let sec = newDate.getSeconds()
      let zhYear = window.localStorage.getItem('lang') === '0' ? '/' : '年'
      let zhMouth = window.localStorage.getItem('lang') === '0' ? '/' : '月'
      let zhDate = window.localStorage.getItem('lang') === '0' ? ' ' : '日'
      month = month < 10 ? '0' + month : month
      Todate = Todate < 10 ? '0' + Todate : Todate
      hour = hour < 10 ? '0' + hour : hour
      min = min < 10 ? '0' + min : min
      sec = sec < 10 ? '0' + sec : sec
      if (type === 'YYMMDDHHMMSS') {
        return year + '/' + month + '/' + Todate + ' ' + hour + ':' + min + ':' + sec
      } else if (type === 'YYMMDD') {
        return year + '/' + month + '/' + Todate
      } else if (type === 'YYMMDDHHMM') {
        return year + '/' + month + '/' + Todate + ' ' + hour + ':' + min
      } else if (type === 'YYMMDDZH') {
        return year + zhYear + month + zhMouth + Todate + zhDate
      }
    }
  },
  returnNewDate (date) {
    if (date === null || date === '' || date === undefined) {
      return ''
    } else {
      return date.split('.')[0].replace('T', ' ')
    }
  },
  showTips (value, time) {
    let dom = document.createElement('div')
    dom.id = 'doubleConfirm'
    dom.classList.add('myRemind')
    dom.innerHTML = value
    document.body.appendChild(dom)
    setTimeout(() => {
      dom.style.opacity = 1
      setTimeout(() => {
        dom.style.opacity = 0
        setTimeout(() => {
          dom.style.opacity = 0
          document.body.removeChild(dom)
        }, 300)
      }, time || 2000)
    }, 10)
  },
  checkIfEmpty (data, list, value) {
    let content = {content: '请检查必填项！'}
    if (value) {
      content = {content: value}
    }
    for (let i in data) {
      if (list.indexOf(i) >= 0 && !data[i]) {
        this.showTips(content.content)
        return true
      }
    }
    return false
  },
  numFixed (num, fixedNum) {
    if (num !== null && num !== undefined) {
      let newFixedNum = fixedNum || 2
      if (fixedNum) {
        return (parseFloat(num).toFixed(newFixedNum) + '').replace(/\d{2,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
      } else {
        return (parseFloat(num).toFixed(newFixedNum) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
      }
    } else {
      return 0
    }
  },
  returnOrderStatus (type, name, order) {
    let intType = parseInt(type)
    if (order === '1') {
      if (name === 'status') {
        switch (intType) {
          case 2:
            return '已购买'
          case 3:
            return '已接单'
          case 4:
            return '已确定'
          case 5:
            return '已作废'
        }
      } else if (name === 'color') {
        switch (intType) {
          case 2:
            return 'allColor0E7BFB'
          case 3:
            return 'allColorFF5319'
          case 4:
            return 'allColor81D533'
          case 5:
            return 'allColor909CA1'
        }
      }
    } else if (order === '2') {
      if (name === 'status') {
        switch (intType) {
          case 1:
            return '未支付'
          case 2:
            return '已购买'
          case 3:
            return '已发货'
          case 4:
            return '已收货'
          case 5:
            return '已作废'
        }
      } else if (name === 'color') {
        switch (intType) {
          case 2:
            return 'allColor0E7BFB'
          case 3:
            return 'allColorFF5319'
          case 4:
            return 'allColor81D533'
          case 5:
            return 'allColor909CA1'
        }
      }
    }
    return ''
  },
  // 隐藏手机号 隐藏身份证 隐藏银行卡
  returnHide (type, num) {
    if (type) {
      if (num === 'phone') {
        let reg = /^(\d{3})\d{4}(\d{4})$/
        return type.replace(reg, '$1****$2')
      } else if (num === 'IdCard') {
        let reg = /^(\d{6})\d{8}(\d{4})$/
        return type.replace(reg, '$1********$2')
      } else if (num === 'bandCard') {
        let reg = /^(\d{4})\d+(\d{4})$/
        return type.replace(reg, '$1********$2')
      }
    }
  },
  returnDigit (type, name) {
    if (type) {
      if (name === 'phone') {
        let reg = /^1[3456789]\d{9}$/
        if (!reg.test(type)) {
          this.showTips('请输入正确的手机号')
          return true
        }
      } else if (name === 'IdCard') {
        let reg = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/
        if (!reg.test(type)) {
          this.showTips('请输入正确的身份证')
          return true
        }
      }
    }
  },
  // base64转file文件
  dataURLtoFile (dataurl, type) {
    let arr = dataurl.split(',')
    let mime = arr[0].match(/:(.*?);/)[1]
    let bstr = atob(arr[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], type, { type: mime })
  },
  returnTimeago(dateTimeStamp){
    let result = ''
    let minute = 1000 * 60;      //把分，时，天，周，半个月，一个月用毫秒表示
    let hour = minute * 60;
    let day = hour * 24;
    let week = day * 7;
    // let halFamonth = day * 15;
    let month = day * 30;
    let now = new Date().getTime();   //获取当前时间毫秒
    let showTime = new Date(dateTimeStamp.replace(/-/g, '/')).getTime();
    let diffValue = now - showTime;//时间差
    if(diffValue < 0){
      return;
    }
    var minC = diffValue/minute;  //计算时间差的分，时，天，周，月
    var hourC = diffValue/hour;
    var dayC = diffValue/day;
    var weekC = diffValue/week;
    var monthC = diffValue/month;
    if(monthC >= 1 && monthC <= 3){
      result = " " + parseInt(monthC) + "月前"
    }else if(weekC >= 1 && weekC <= 3){
      result = " " + parseInt(weekC) + "周前"
    }else if(dayC >= 1 && dayC <= 6){
      result = " " + parseInt(dayC) + "天前"
    }else if(hourC >= 1 && hourC <= 23){
      result = " " + parseInt(hourC) + "小时前"
    }else if(minC >= 1 && minC <= 59){
      result =" " + parseInt(minC) + "分钟前"
    }else if(diffValue >= 0 && diffValue <= minute){
      result = "刚刚"
    }else {
      result = dateTimeStamp
    }
    return result;
  }
}
